var map = {
	"./banner-1.jpg": "TsUD",
	"./banner-2.jpg": "X8kJ",
	"./banner-3.jpg": "Vg1l",
	"./banner-bimbel-snbt-2023.jpg": "vvyG",
	"./banner-ngambis.jpg": "llUi",
	"./banner-ngambisz.jpg": "P7KP",
	"./banner-skd.png": "Cfzn",
	"./banner-skdx.png": "a/jN",
	"./banner-snbt.jpg": "vhOJ",
	"./banner-stiu.jpg": "X2wc",
	"./banner-tiu.jpg": "/C9F",
	"./banner-tiu1.jpg": "WtZW",
	"./banner-to-snbt-2023.jpg": "mvjx",
	"./banner-to.jpg": "ZnSd",
	"./banner-utbk.jpg": "Hlw2",
	"./jadwal-skda.jpg": "ziBj",
	"./jadwal-skdb.jpg": "yslz"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "AHjQ";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banners nonrecursive \.png$|\.jpg$
// module id = AHjQ
// module chunks = 1